import sanityClient from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

export const client = sanityClient({
projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
dataset: 'production',
apiVersion: '2022-01-26',
useCdn: true,
token: process.env.REACT_APP_SANITY_TOKEN,


});

const builder = imageUrlBuilder(client)
// The above is used at Pin.js inside the component folder
export const urlFor = (source) => { 
    return builder.image(source)
    }